<template>
  <el-select clearable v-model="areaId" :size="size"  style="width: 100%;" placeholder="选择区域" @change="updateParentComponent">
    <el-option
      v-for="item in areaList"
      :key="item.id"
      :label="item.areaName"
      :value="item.id">
    </el-option>
  </el-select>
</template>

<script>
import { QuerySysArea } from '@/api/sys/sys_area'
import util from "@/libs/util";
var _ = require('lodash')
export default {
  name: 'SelectArea',
  data () {
    return {
      areaList: [],
      areaObj: {},
      value: null
    }
  },
  props: {
    size: {
      default: null
    },
    areaId: {
      default: null
    }
  },
  mounted () {
    this.queryAreaAll()
  },
  methods: {
    queryAreaAll () {
        let areaList = util.cookies.get("areaList")
        // console.log("获取模块" +priceList )
        if(areaList !== undefined && areaList !== ''){
            this.areaList = JSON.parse(areaList);
        }else {
            QuerySysArea({'page': 1, 'size': 20000}).then(res => {
                this.areaList = res.success.list
                util.cookies.set("areaList",JSON.stringify(this.areaList))
            }).catch(err => {
                console.error('err', err)
            })
        }
    },
    updateParentComponent (event) {
      if (event === null) {
        this.$emit('selectedAreaId', null)
      } else {
        let index = _.findIndex(this.areaList, function (o) { return o.id === event })
        this.$emit('selectedAreaId', index !== -1 ? this.areaList[index] : null)
      }
    }
  }
}
</script>

<style scoped>

</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/system/area/componnets/SelectArea/SelectArea.vue"
}
</vue-filename-injector>
